<template>
    <div class="page-container">
        <div class="loading-container" v-if="loading">
            <div class="loading-spinner"></div>
            <p class="loading-text">正在准备跳转到微信小程序...</p>
        </div>
        <div class="content-container" v-else>
            <!-- 这里可以放置非加载状态下的内容 -->
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
        };
    },
    created() {
        this.getGenerateScheme();
    },
    methods: {
        /**
         * 获取微信小程序短链并根据系统类型打开
         * @description 获取微信小程序短链，判断当前手机系统是否为iOS，然后通过不同方式触发短链打开微信小程序
         */
        getGenerateScheme() {
            // 显示加载状态
            this.loading = true;

            let params = {
                path: '/pages/marketing/AIInterview/webview',
                query: 'unique_id=' + this.$route.query.unique_id,
            };

            this.http.get("/wx/ma/getGenerateScheme", params )
                .then((res) => {
                    let url = res.data.data;
                    if (url) {
                        // 判断当前设备是否为iOS系统
                        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

                        // 延迟执行跳转，让用户看到加载状态
                        setTimeout(() => {
                            if (isIOS) {
                                // iOS系统直接使用window.location跳转
                                window.location.href = url;
                            } else {
                                // 安卓系统使用a标签模拟点击
                                const link = document.createElement('a');
                                link.href = url;
                                link.style.display = 'none';
                                document.body.appendChild(link);
                                link.click();
                                // 清理DOM
                                setTimeout(() => {
                                    document.body.removeChild(link);
                                }, 100);
                            }
                        }, 800); // 延迟800ms，提供更好的视觉反馈
                    } else {
                        // 如果没有获取到URL，关闭加载状态
                        this.loading = false;
                    }
                })
                .catch((error) => {
                    console.error('获取微信小程序短链失败:', error);
                    this.loading = false;
                });
        }
    }
};
</script>

<style lang='less' scoped>
.page-container {
    position: relative;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .loading-spinner {
            width: 40px;
            height: 40px;
            border: 3px solid rgba(0, 0, 0, 0.1);
            border-radius: 50%;
            border-top-color: #409EFF;
            animation: spin 1s ease-in-out infinite;
            margin-bottom: 16px;
        }

        .loading-text {
            font-size: 14px;
            color: #606266;
            margin: 0;
        }
    }

    .content-container {
        width: 100%;
    }
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>